/**
 * Polyfill stable language features. These imports will be optimized by `@babel/preset-env`.
 *
 * See: https://github.com/zloirock/core-js#babel
 */
import 'core-js/stable';
import 'reflect-metadata';
import 'regenerator-runtime/runtime';
// This fixes a 'global is not defined' webpack error
(window as any).global = window;
